import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapComponent } from './map.component';
import { AuthGuardService } from '../_services/auth-guard.service';

const routes: Routes = [
  { path: '', component: MapComponent, canActivate: [AuthGuardService] },
  { path: ':objectType', component: MapComponent, canActivate: [AuthGuardService]},
  { path: ':objectType/:objectId', component: MapComponent, canActivate: [AuthGuardService]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MapRoutingModule { }

